import React from "react";

import "./Message.styles.scss";

interface MessageProps {
  text?: string;
  additionalClass?: string;
}

const ErrorMessage = ({ text, additionalClass }: MessageProps) => {
  const messageClasses = !additionalClass
    ? `pricing_message`
    : `pricing_message ${additionalClass}`;

  return (
    <>
      {text ? (
        <p
          className={messageClasses}
          dangerouslySetInnerHTML={{ __html: text }}
        ></p>
      ) : null}
    </>
  );
};

export default ErrorMessage;
